export const stringToColor = (string) => {
  if (!string) return 'support.teal'

  const colors = [
    'secondary.main',
    'support.lilac',
    'support.teal',
    'success.dark',
    'support.osprey',
    'secondary.light',
    'support.navy',
    'secondary.dark',
    'info.main'
  ]

  const charCode = string[0].charCodeAt(0)
  const index = charCode % colors.length
  return colors[index]
}
